var _style, _g, _g2, _path, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#252A41;}\n\t.st1{fill:none;}\n\t.st2{fill:#98A2BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    transform: "translate(-573 -450)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    className: "st0",
    d: "M387.47,456.89h-9.46c-0.87,0-1.58,0.71-1.58,1.58v8.55c0,0.87,0.71,1.58,1.58,1.58h9.45 c0.87,0,1.58-0.71,1.58-1.58v-8.55C389.05,457.6,388.34,456.89,387.47,456.89C387.47,456.89,387.47,456.89,387.47,456.89z  M387.47,467.24h-9.46c-0.12,0-0.22-0.1-0.22-0.22v-8.55c0-0.12,0.1-0.22,0.22-0.22h9.45c0.12,0,0.22,0.1,0.23,0.22v8.55 C387.69,467.14,387.59,467.23,387.47,467.24L387.47,467.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    className: "st0",
    d: "M382.74,460.77c-0.37,0-0.68,0.3-0.68,0.68l0,0v2.59c0,0.37,0.3,0.68,0.68,0.67 c0.37,0,0.67-0.3,0.67-0.67v-2.59C383.41,461.07,383.11,460.77,382.74,460.77C382.74,460.77,382.74,460.77,382.74,460.77z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    className: "st0",
    d: "M382.67,450.35c-2.39,0.04-4.33,1.97-4.36,4.36v3.18h1.35v-3.17c0-1.7,1.38-3.08,3.08-3.08 c0,0,0,0,0,0c1.7,0,3.08,1.38,3.08,3.08v2.17h1.35v-2.17C387.13,452.27,385.12,450.31,382.67,450.35 C382.67,450.35,382.67,450.35,382.67,450.35z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    transform: "translate(-608 -909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_481",
    transform: "translate(608 909)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-150-1c6.08,0,11,4.92,11,11s-4.92,11-11,11s-11-4.92-11-11S-156.08-1-150-1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-150,0c-5.51,0-10,4.49-10,10s4.49,10,10,10s10-4.49,10-10S-144.49,0-150,0 M-150-1c6.08,0,11,4.92,11,11 s-4.92,11-11,11s-11-4.92-11-11S-156.08-1-150-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(614.696 915.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -161,
    y: 2.8,
    className: "st2",
    width: 8.61,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -157.2,
    y: -1,
    className: "st2",
    width: 1,
    height: 8.61
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user_1_",
    className: "st2",
    d: "M-62.22,2.22c-4.3-4.3-11.26-4.3-15.56,0s-4.3,11.26,0,15.56s11.26,4.3,15.56,0 S-57.93,6.52-62.22,2.22z M-76.23,17.45c0.38-3.15,3.05-5.53,6.23-5.54c3.18,0,5.85,2.38,6.23,5.54 C-67.38,20.47-72.62,20.47-76.23,17.45z M-70,10.58c-1.85,0-3.34-1.5-3.34-3.34s1.5-3.34,3.34-3.34s3.34,1.5,3.34,3.34v0 C-66.66,9.09-68.15,10.58-70,10.58z M-62.66,16.36c-0.61-2.44-2.38-4.42-4.74-5.29c2.12-1.43,2.68-4.31,1.25-6.43 c-1.43-2.12-4.31-2.68-6.43-1.25c-2.12,1.43-2.68,4.31-1.25,6.43c0.33,0.49,0.75,0.91,1.25,1.25c-2.36,0.86-4.14,2.84-4.75,5.28 c-3.51-4.05-3.07-10.18,0.98-13.69s10.18-3.07,13.69,0.98C-59.5,7.29-59.5,12.71-62.66,16.36L-62.66,16.36z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    transform: "translate(-608 -909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_481_1_",
    transform: "translate(608 909)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-110-1c6.08,0,11,4.92,11,11s-4.92,11-11,11s-11-4.92-11-11S-116.08-1-110-1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-110-0.12c-2.7,0-5.24,1.05-7.16,2.96s-2.96,4.45-2.96,7.16s1.05,5.24,2.96,7.16 c1.91,1.91,4.45,2.96,7.16,2.96s5.24-1.05,7.16-2.96c1.91-1.91,2.96-4.45,2.96-7.16s-1.05-5.24-2.96-7.16S-107.3-0.12-110-0.12  M-110-1c6.08,0,11,4.92,11,11s-4.92,11-11,11s-11-4.92-11-11S-116.08-1-110-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_619"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "498.14,922.64 493.72,918.21 494.34,917.59 498.14,921.39 501.95,917.59 502.57,918.21  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    transform: "translate(-571.564 -448.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398_1_",
    transform: "translate(160.503 -149.168) rotate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552_1_",
    className: "st0",
    d: "M547.23,466.68l-9.46,0c-0.87,0-1.58,0.71-1.58,1.58v8.55c0,0.87,0.71,1.58,1.58,1.58h9.45 c0.87,0,1.58-0.71,1.58-1.58v-8.55C548.81,467.39,548.1,466.68,547.23,466.68C547.23,466.68,547.23,466.68,547.23,466.68z  M547.23,477.03h-9.46c-0.12,0-0.22-0.1-0.22-0.22v-8.55c0-0.12,0.1-0.22,0.22-0.22l9.45,0c0.12,0,0.22,0.1,0.23,0.22v8.55 C547.45,476.93,547.35,477.03,547.23,477.03L547.23,477.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553_1_",
    className: "st0",
    d: "M542.5,470.56c-0.37,0-0.68,0.3-0.68,0.68l0,0v2.59c0,0.37,0.3,0.68,0.68,0.67 c0.37,0,0.67-0.3,0.67-0.67v-2.59C543.18,470.86,542.88,470.56,542.5,470.56C542.5,470.56,542.5,470.56,542.5,470.56z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_554_1_",
    className: "st0",
    d: "M542.62,447.97c-2.37,0.33-4.05,2.48-3.8,4.86l0.39,3.15l1.34-0.17l-0.39-3.15 c-0.21-1.69,0.99-3.22,2.68-3.43c0,0,0,0,0,0c1.69-0.21,3.22,0.99,3.43,2.68l0.27,2.16l1.34-0.16l-0.26-2.16 C547.28,449.34,545.04,447.64,542.62,447.97C542.62,447.97,542.62,447.97,542.62,447.97z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    className: "st2",
    d: "M12.23,14.78v1.06c0,0.35-0.29,0.64-0.64,0.64l0,0H4.37c-0.35,0-0.64-0.29-0.64-0.64c0,0,0,0,0,0 V6.07c0-0.35,0.29-0.64,0.64-0.64l0,0h1.91v7.85c0,0.82,0.67,1.48,1.49,1.49L12.23,14.78z M12.23,5.65V2.89H7.77 c-0.35,0-0.63,0.29-0.63,0.64v9.76c0,0.35,0.29,0.64,0.64,0.64l0,0h7.22c0.35,0,0.64-0.29,0.64-0.64l0,0v-7h-2.76 C12.51,6.29,12.23,6,12.23,5.65L12.23,5.65z M15.44,4.82l-1.75-1.75c-0.12-0.12-0.28-0.19-0.45-0.19h-0.16v2.55h2.55V5.27 C15.63,5.1,15.56,4.94,15.44,4.82L15.44,4.82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy);
export default __webpack_public_path__ + "static/media/icons_copy.bafbeace.svg";
export { ForwardRef as ReactComponent };